import { useState, useEffect } from "react";
import { getData } from "../../../services/library";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Container,
  TextField,
  Stack,
  Grid,
  Divider,
  Button,
  Typography,
  Chip
} from "@mui/material";
import moment from "moment";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { formatoDisplay } from "./functions";
// import {getData} from "../../../services/library";
import DialogViewOC from "./DialogViewOC";
import Slide from '@mui/material/Slide';
import { forwardRef } from 'react';
import Title from "../../TitleUploaded";
import UploadFiles from "../UploadFiles";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});
export default function Fichacomprobante(props) {
  const navigate = useNavigate();
  /* ----------------------- ESTADOS & REFS ------------------------*/
  const [cuerpo, setCuerpo] = useState([]);
  const [pie, setPie] = useState([]);
  const [openclose, setOpenClose] = useState(false);
  const [ocs, setOcs] = useState([]);
  const [showDialogDetalleOC, setShowDialogDetalleOC] = useState(false);
  const [idOcAbro, setIdOcAbro] = useState();

  const handleAbrirOC = (idOrdenCompra) => {
    setShowDialogDetalleOC(true);
    setIdOcAbro(idOrdenCompra)
  };

  /* ----------------------- EFFECTS ------------------------*/
  useEffect(() => {
    getData(
      "/comprobantes_cuerpo/x_uuid/" + props.datos.uuid_comprobante,
      setCuerpo
    );
    getData("/comprobantes_pie/xuuid/" + props.datos.uuid_comprobante, setPie);
    getData("/comprobantes_ocs/" + props.datos.idcomprobante, setOcs);
  }, [props.datos]);

  /* ----------------------- STYLING ------------------------*/


  // const totalNetoGravado = pie?.reduce((acc, row) => acc + (Number(row.importe_neto_gr) || 0), 0) || 0;
  const totalNetoGravado = props.datos?.neto_gravado;


  const valorOtrosTributos = pie?.[0]?.otros_tributos || 0;
  const campos = [
    { label: "Proveedor", value: props.datos?.razon_social || props.datos?.nombre_fantasia || "Sin asignar", xs: 4 },
    { label: "Condición", value: props.datos?.condicion_pago || "---", xs: 3 },
    { label: "Sucursal", value: props.datos?.nombre || "---", xs: 3 },
    { label: "Empresa", value: props.datos?.empresa || "---", xs: 2 },
    { label: "Tipo comprobante", value: props.datos?.tipo_comprobante || "---", xs: 3 },
    { label: "Número", value: props.datos?.nro_comprobante || "---", xs: 3 },
    { label: "Fecha comprobante", value: props.datos?.fecha_factura ? moment(props.datos.fecha_factura).format("DD-MM-YYYY") : "---", xs: 3 },
    { label: "Vencimiento", value: props.datos?.vto_factura ? moment(props.datos.vto_factura).format("DD-MM-YYYY") : "---", xs: 3 },
    { label: "Moneda", value: props.datos?.tipomoneda || "ARS", xs: 3 },
    { label: "Cambio", value: props.datos?.tipo_cambio || "", xs: 3 },
    { label: "Total", value: `$${formatoDisplay(props.datos?.total || 0)}`, xs: 3, bold: true },
  ];


  return (
    <div>
      <Container maxWidth="xl">

        <Title
          title={"Comprobante Nro°" + props.datos.idcomprobante}
          handleClose={() => [props.ficha(false), props.tabla(true)]}
        />
        <Box
          sx={{
            mt: 1,
            p: 1.5,
            backgroundColor: "#fff",
            borderRadius: 1,
            border: "1px solid #d1d5db",
            fontSize: "0.85rem" // Achicamos la base de fuente
          }}
        >
          <Box sx={{ mt: 1, p: 1.2, backgroundColor: "#fff", borderRadius: 1, border: "1px solid #d1d5db" }}>

            {/* CABECERA: Título y Adjunto alineados */}
            <Box display="flex" justifyContent="space-between" alignItems="center" mb={1.5}>
              <Typography sx={{ fontWeight: 800, color: "#334155", fontSize: "0.85rem", textTransform: 'uppercase' }}>
                {props.datos?.tipo_comprobante || "DETALLE"} Nº {props.datos?.nro_comprobante || "---"}
              </Typography>
              <Button
                variant="outlined"
                size="small"
                startIcon={<AttachFileIcon sx={{ fontSize: 16 }} />}
                onClick={() => setOpenClose(!openclose)}
                sx={{ textTransform: 'none', py: 0.2, height: '26px', fontSize: '0.75rem' }}
              >
                Ver Adjunto
              </Button>
            </Box>

            <Grid container sx={{ bgcolor: "#f8fafc", borderRadius: 0.8, border: '1px solid #e2e8f0', overflow: 'hidden' }}>

              {campos.map((c, i) => (
                <Grid
                  item
                  key={i}
                  xs={c.label === "Proveedor" ? 3 : 2}
                  sx={{
                    p: 1.2,
                    borderRight: '1px solid #e2e8f0',
                    borderBottom: '1px solid #e2e8f0',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    minHeight: '50px'
                  }}
                >
                  <Typography
                    sx={{ color: "#64748b", fontWeight: 800, fontSize: '0.65rem', textTransform: 'uppercase', lineHeight: 1.1, mb: 0.3 }}
                  >
                    {c.label}
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: "0.85rem",
                      fontWeight: c.bold ? 700 : 500,
                      color: "#1e293b",
                      whiteSpace: 'nowrap',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis'
                    }}
                    title={c.value}
                  >
                    {c.value || "---"}
                  </Typography>
                </Grid>
              ))}

              <Grid item xs={2} sx={{ p: 1.2, borderBottom: '1px solid #e2e8f0', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                <Typography sx={{ color: "#64748b", fontWeight: 800, fontSize: '0.65rem', textTransform: 'uppercase', lineHeight: 1.1, mb: 0.3 }}>
                  OCs
                </Typography>
                <Box sx={{ display: 'flex', gap: 0.5, flexWrap: 'wrap' }}>
                  {ocs?.length > 0 ? ocs.map((oc, i) => (
                    <Chip
                      key={i}
                      label={oc.id_oc}
                      size="small"
                      variant="filled"
                      onClick={() => handleAbrirOC(oc.id_oc)}
                      sx={{
                        height: 18,
                        fontSize: '0.65rem',
                        borderRadius: 0.5,
                        bgcolor: '#e2e8f0',
                        color: '#475569',
                        fontWeight: 700,
                        cursor: 'pointer',
                        '&:hover': { bgcolor: '#cbd5e1' }
                      }}
                    />
                  )) : <Typography sx={{ fontSize: '0.75rem', color: '#94a3b8' }}>---</Typography>}
                </Box>
              </Grid>
            </Grid>
          </Box>
          <Box sx={{ display: 'flex', gap: 2, alignItems: 'flex-start' }}>

            <Box sx={{ flex: 2 }}>
              {cuerpo?.filter(r => r.id_porcentajeiva !== null).length > 0 && (
                <TableContainer component={Box} sx={{ border: "1px solid #e2e8f0", borderRadius: 1 }}>
                  <Table size="small">
                    <TableHead sx={{ bgcolor: "#f1f5f9" }}>
                      <TableRow>
                        <TableCell sx={{ py: 0.5, fontWeight: 700, fontSize: "0.75rem" }}>DETALLE</TableCell>
                        <TableCell align="right" sx={{ py: 0.5, fontWeight: 700, fontSize: "0.75rem" }}>NETO</TableCell>
                        <TableCell align="center" sx={{ py: 0.5, fontWeight: 700, fontSize: "0.75rem" }}>IVA</TableCell>
                        <TableCell align="right" sx={{ py: 0.5, fontWeight: 700, fontSize: "0.75rem" }}>MONTO IVA</TableCell>
                        <TableCell align="right" sx={{ py: 0.5, fontWeight: 700, fontSize: "0.75rem" }}>IMPUTACIÓN</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {cuerpo.filter(r => r.id_porcentajeiva !== null).map((row, i) => (
                        <TableRow key={i} sx={{ '&:last-child td': { border: 0 } }}>
                          <TableCell sx={{ py: 0.5, fontSize: "0.8rem" }}>{row.detalle_productos}</TableCell>
                          <TableCell align="right" sx={{ py: 0.5, fontSize: "0.8rem" }}>${formatoDisplay(row.subtotal)}</TableCell>
                          <TableCell align="center" sx={{ py: 0.5, fontSize: "0.8rem" }}>{row.porcentaje_iva}%</TableCell>
                          <TableCell align="right" sx={{ py: 0.5, fontSize: "0.8rem", fontWeight: 600 }}>
                            ${formatoDisplay((row.monto_iva ? row.monto_iva : (row.subtotal_iva - row.subtotal)).toFixed(2))}
                          </TableCell>
                          <TableCell align="right" sx={{ py: 0.5, fontSize: "0.8rem" }}>{row.imputacion}</TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              )}

              {cuerpo?.some(r => r.id_impuesto !== null) && (
                <Box sx={{ mt: 1, p: 1, border: '1px dashed #cbd5e1', borderRadius: 1, display: 'flex', gap: 2 }}>
                  <Typography sx={{ fontSize: '0.75rem', fontWeight: 700, color: '#94a3b8' }}>IMPUESTOS:</Typography>
                  {cuerpo.filter(r => r.id_impuesto !== null).map((row, i) => (
                    <Typography key={i} sx={{ fontSize: '0.75rem', fontWeight: 600 }}>
                      {row.impuesto}: ${formatoDisplay(row.importe)}
                    </Typography>
                  ))}
                </Box>
              )}

            </Box>

            <Box sx={{ flex: 1, minWidth: '220px', bgcolor: "#f8fafc", border: "1px solid #e2e8f0", borderRadius: 1, p: 1.5 }}>
              <Typography sx={{ fontSize: '0.7rem', fontWeight: 800, color: '#64748b', mb: 1, borderBottom: '1px solid #e2e8f0' }}>
                RESUMEN CONTABLE
              </Typography>

              {totalNetoGravado && (
                <Box display="flex" justifyContent="space-between" mb={0.5}>
                  <Typography sx={{ fontSize: '0.75rem' }}>Neto Gravado:</Typography>
                  <Typography sx={{ fontSize: '0.75rem', fontWeight: 600 }}>${formatoDisplay(totalNetoGravado)}</Typography>
                </Box>
              )}

              {pie?.filter(row => Number(row.importe) > 0).map((row, i) => (
                <Box key={i} display="flex" justifyContent="space-between" mb={0.5}>
                  <Typography sx={{ fontSize: '0.75rem' }}>IVA {row.porcentajeiva}%:</Typography>
                  <Typography sx={{ fontSize: '0.75rem', fontWeight: 600 }}>${formatoDisplay(row.importe)}</Typography>
                </Box>
              ))}

              {/* {Number(valorOtrosTributos) > 0 && (
                <Box display="flex" justifyContent="space-between" mb={1}>
                  <Typography sx={{ fontSize: '0.75rem' }}>Otros Tributos:</Typography>
                  <Typography sx={{ fontSize: '0.75rem', fontWeight: 600 }}>${formatoDisplay(valorOtrosTributos)}</Typography>
                </Box>
              )} */}

              {cuerpo?.some(r => r.id_impuesto !== null) && (
                <Box display="flex" justifyContent="space-between" mb={0.5}>
                  <Typography sx={{ fontSize: '0.75rem' }}>
                    Otros Tributos:
                  </Typography>
                  <Typography sx={{ fontSize: '0.75rem', fontWeight: 600 }}>
                    ${formatoDisplay(
                      cuerpo
                        .filter(r => r.id_impuesto !== null)
                        .reduce((acc, row) => {
                          const valor = typeof row.importe === 'string'
                            ? parseFloat(row.importe.replace(/\./g, "").replace(/,/g, "."))
                            : row.importe;
                          return acc + (valor || 0);
                        }, 0)
                        .toFixed(2)
                        .replace(".", ",")
                    )}
                  </Typography>
                </Box>
              )}



              <Box sx={{
                mt: 1, pt: 1, borderTop: "2px solid #334155",
                display: "flex", justifyContent: "space-between", alignItems: "center"
              }}>
                <Typography sx={{ fontSize: '0.8rem', fontWeight: 800 }}>TOTAL</Typography>
                <Typography sx={{ fontSize: '1.1rem', fontWeight: 900, color: "#2563eb" }}>
                  ${formatoDisplay(props.datos?.total || 0)}
                </Typography>
              </Box>
            </Box>
          </Box>
        </Box>
      </Container>
      {openclose ? (
        <UploadFiles
          fileId={props.datos.uuid_comprobante}
          open={openclose}
          setOpen={setOpenClose}
          title="Documentos cargados"
        />
      ) : null}
      {
        showDialogDetalleOC && (
          <DialogViewOC
            open={showDialogDetalleOC}
            handleClose={() => {
              setShowDialogDetalleOC(false);
            }}
            TransitionComponent={Transition}
            idOrdenCompra={idOcAbro}
          />
        )
      }
      <br />
      <br />
    </div>
  );
}

